export default {
  placeholder: 'Wybierz wydarzenie',
};
